<div class="search-input-container">
  @if (!currentInputValue?.length) {
    <div class="icon-container">
      <svg-icon src="assets/icons/zoom.svg" [svgStyle]="{ 'width.px':21 }"></svg-icon>
    </div>
  }

  <input
    type="text"
    class="input-value"
    (input)="updateValue()"
    [(ngModel)]="currentInputValue"
    placeholder="{{ 'strategies.filtrationLabels.searchPlaceholder' | translate }}"
    >

  <hr class="underline">
</div>